import type { KeyboardNavigatorParams } from './types';

const keyboardNavigationEventHandler = (params: KeyboardNavigatorParams) => {
  const {
    key,
    keyboardNavigatorKeymap: keyIndexList,
    selectedItem,
    setSelectedItem,
    value,
  } = params;
  if (keyIndexList === null || keyIndexList.length === 0) {
    return;
  }
  const colLength = keyIndexList.length;
  switch (key) {
    case 'ArrowDown': {
      if (selectedItem === null) {
        setSelectedItem({
          col: 0,
          index: 0,
        });
        return;
      }
      const nextIndex = {
        col: selectedItem.col,
        index:
          selectedItem.index + 1 > keyIndexList[selectedItem.col].length - 1
            ? 0
            : selectedItem.index + 1,
      };
      setSelectedItem(nextIndex);
      return;
    }

    case 'ArrowUp': {
      if (selectedItem === null) {
        setSelectedItem({
          col: 0,
          index: keyIndexList?.[0].length - 1 || 0,
        });
        return;
      }
      const nextIndex = {
        col: selectedItem.col,
        index:
          selectedItem.index - 1 < 0
            ? keyIndexList[selectedItem.col].length - 1
            : selectedItem.index - 1,
      };
      setSelectedItem(nextIndex);
      return;
    }

    case 'ArrowRight':
      if (selectedItem === null) return;
      setSelectedItem({
        col: selectedItem.col + 1 > colLength - 1 ? 0 : selectedItem.col + 1,
        index: selectedItem.index,
      });
      return;
    case 'ArrowLeft':
      if (selectedItem === null) return;
      setSelectedItem({
        col: selectedItem.col - 1 < 0 ? colLength - 1 : selectedItem.col - 1,
        index: selectedItem.index,
      });
      return;
    case 'Enter':
      if (selectedItem === null) return;
      keyIndexList[selectedItem.col]?.[selectedItem.index]?.action(value);
      return;
  }
};

const keyboardNavigatorUtils = {
  keyboardNavigationEventHandler,
};

export default keyboardNavigatorUtils;
